import { render, staticRenderFns } from "./owner_post.vue?vue&type=template&id=2ceffa96&scoped=true"
import script from "./owner_post.vue?vue&type=script&lang=js"
export * from "./owner_post.vue?vue&type=script&lang=js"
import style0 from "./owner_post.vue?vue&type=style&index=0&id=2ceffa96&prod&lang=css"
import style1 from "./owner_post.vue?vue&type=style&index=1&id=2ceffa96&prod&scoped=true&lang=css"
import style2 from "./owner_post.vue?vue&type=style&index=2&id=2ceffa96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceffa96",
  null
  
)

export default component.exports